(() => {
  const dialog = document.getElementById('owl-age-declaration');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const key = 'owl-age-declaration-v1';
  const days = 30 * 24 * 60 * 60 * 1000;
  const read = storage => {
    try {
      const record = JSON.parse(storage.getItem(key));
      return record?.version === 1 && record.confirmed === true && Number.isFinite(record.expires) && record.expires > Date.now() && record.expires <= Date.now() + days;
    } catch { return false; }
  };
  let accepted = false;
  try { accepted = read(window.sessionStorage) || read(window.localStorage); } catch {}
  if (accepted) return;
  const enter = dialog.querySelector('[data-owl-age-enter]');
  const leave = dialog.querySelector('[data-owl-age-leave]');
  const prompt = dialog.querySelector('[data-owl-age-prompt]');
  const declined = dialog.querySelector('[data-owl-age-declined]');
  const remember = dialog.querySelector('[data-owl-age-remember]');
  const before = document.activeElement;
  const previousOverflow = document.documentElement.style.overflow;
  document.documentElement.style.overflow = 'hidden';
  dialog.addEventListener('cancel', event => event.preventDefault());
  dialog.showModal();
  leave.focus();
  enter.addEventListener('click', () => {
    const record = JSON.stringify({ version: 1, confirmed: true, expires: Date.now() + days });
    try { window.sessionStorage.setItem(key, record); } catch {}
    if (remember.checked) { try { window.localStorage.setItem(key, record); } catch {} }
    dialog.close();
    document.documentElement.style.overflow = previousOverflow;
    if (before instanceof HTMLElement) before.focus();
  });
  leave.addEventListener('click', () => {
    prompt.hidden = true;
    declined.hidden = false;
    declined.querySelector('[data-owl-age-exit-title]').focus();
  });
  dialog.querySelector('[data-owl-age-back]').addEventListener('click', () => {
    declined.hidden = true;
    prompt.hidden = false;
    leave.focus();
  });
})();

